import { Pipe, PipeTransform } from '@angular/core';

import { DprActivityCustomDataGridData } from '@dpr-details/models/grid';
import { computeDiffTimeAsHours, convertTimeToDate } from '@shared/utils';

@Pipe({
  name: 'calculatedCustomData',
})
export class CalculatedCustomDataPipe implements PipeTransform {
  transform(
    customDataId: number,
    dprActivityCustomDataList: DprActivityCustomDataGridData[],
    start: string,
    finish: string,
    activityId: number | string
  ): string {
    if (!activityId || !customDataId || !dprActivityCustomDataList?.length) {
      return null;
    }

    const customData = dprActivityCustomDataList.find(
      (x) => x.customDataId === customDataId
    );

    if (customData?.value == null) {
      return null;
    }

    const duration = computeDiffTimeAsHours(
      convertTimeToDate(finish),
      convertTimeToDate(start)
    );

    if (duration < 0) {
      return null;
    }

    return (+customData.value * duration).toFixed(2);
  }
}
